import * as React from "react";

class EditableSectionContent extends React.Component {
    render() {
        return this.props.children || null;
    }
}

export default EditableSectionContent;